import { cn } from '../../../lib/utils';
import { SearchIcon } from '../../bs-icons';

export interface SearchInputProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchInput = ({
  value,
  onChange,
  placeholder = '搜索智能体名称',
  className,
}: SearchInputProps) => {
  return (
    <div
      className={cn(
        'content-stretch flex items-center gap-[6px] border border-[#e0e0e0] border-solid rounded-[4px] px-[10px] h-[34px]',
        'group hover:border-[#0265ff] focus-within:border-[#0265ff]',
        className,
      )}
    >
      <SearchIcon className="shrink-0 text-[#999] group-hover:text-[#0265ff] group-focus-within:text-[#0265ff]" />
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        className="flex-1 outline-none text-[14px] placeholder:text-[#999] bg-transparent min-w-0 text-[#030303] leading-[normal]"
      />
    </div>
  );
};
